/* eslint-disable no-unused-vars */
/* eslint-disable no-extra-semi */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';

import { getCustomerUsersList, updateCustomerTrackingUser, _createCustomerUserSuccess } from '../../../../../../redux/tracking-manager';
import { getRecipientUsersList } from '../../../../../../redux/recipient-tracking';
import { changeFilters, getNFList } from '../../../../../../redux/tracking';

import Tooltip from '../../../../../RecipientTracking/Tooltip';

import TrackingTable from './TrackingTable';
import NewRecipientForm from './NewRecipientForm';
import EditRecipientForm from './EditRecipientForm';

import ConfirmationModal from '../../../../../RecipientTracking/ConfirmationModal';

import Button from '../../../../../../components/Button';
import Toggle from '../../../../../../components/Toggle';

import Mask from '../../../../../../utils/Mask';

import ErrorIcon from '../../../../../../assets/images/icn_error-outline.svg';

import { S } from './styles';

class TrackingManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditForm: false,
      showConfirmationModal: {
        open: false,
        data: null,
      },
      currentCustomerUser: {},
      currentUser: {},
    };

    this.onRenderCell = this.onRenderCell.bind(this);
    this.handleEditUser = this.handleEditUser.bind(this);
    this.handleConfirmationModal = this.handleConfirmationModal.bind(this);
    this.handleAddCustomer = this.handleAddCustomer.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  handleEditUser(data) {
    const { setShowTable, setShowNewForm } = this.props;

    this.setState({ 
      showEditForm: true, 
      currentCustomerUser: data,
    });
    setShowNewForm(false);
    setShowTable(false);
  };

   // eslint-disable-next-line react/sort-comp
  tableConfig = {
    tableHeaders: [
      {
        name: 'Name',
        label: 'Nome',
        boldPrimary: true,
      },
      {
        name: 'Phone',
        label: 'Telefone',
      },
      {
        name: 'Email',
        label: 'E-mail',
      },
      {
        name: 'CADASTRO',
        label: 'Situação cadastro',
      },
      {
        name: 'HasTracking',
        label: 'Rastreio',
      },
    ],
    tableActions: [
      {
        name: 'edit',
        label: 'Editar',
        iconName: 'mode_edit',
        actionFn: (data) => this.handleEditUser(data),
      },
    ],
  };

  reloadPage(currentPage) {
    const { dispatch } = this.props;
    dispatch(changeFilters({ currentPage }));
    dispatch(getNFList());
  }

  async handleSubmitChangeTracking() {
    const { dispatch, currentCustomerData, loggedCompanyId, currentPage } = this.props;

    await dispatch(updateCustomerTrackingUser({
      taxNumber: currentCustomerData.cnpjDest,
      userId: this.state.showConfirmationModal.data.Id,
      hasTracking: !this.state.showConfirmationModal.data.HasTracking,
    }));

    this.reloadPage(currentPage);

    this.setState({ showConfirmationModal: { open: false, data: null } });
    dispatch(getRecipientUsersList({ companyId: loggedCompanyId, page: 1 }));
  }

  handleConfirmationModal(value) {
    this.setState({ showConfirmationModal: { open: true, data: value } });
  }

  onRenderCell(column, value, row) {
    switch (column) {
      case 'Phone': {
        return Mask.tel(value);
      }

      case 'CADASTRO': {
        return (
          <S.TableRegister status={value}>
            {value === 'Ativado' && (
              <S.RegisterSituation>
                <span>{value}</span>
              </S.RegisterSituation>
            )}
            {value === 'Pendente' && (
              <S.RegisterSituation>
                <span>{value}</span>
                <Tooltip
                  text="Para garantir a segurança dos dados, o rastreio de pedidos é disponibilizado apenas para destinatários autorizados por você. Ao adicionar um contato, ele receberá um link no e-mail para ativar seu cadastro."
                >
                  <S.RegisterExpiredLink onClick={() => this.handleResendEmail(row.Id)}>
                    reenviar link
                  </S.RegisterExpiredLink>
                </Tooltip>
              </S.RegisterSituation>
            )}
            {value === 'Prazo expirado' && (
              <S.RegisterSituation>
                <span>{value}</span>
                <Tooltip
                  text="O rastreio para destinatários permite que contatos cadastrados acompanhem o rastreio dos seus pedidos em tempo real."
                >
                  <S.RegisterExpiredLink onClick={() => this.handleResendEmail(row.Id)}>
                    reenviar link
                  </S.RegisterExpiredLink>
                </Tooltip>
              </S.RegisterSituation>
            )}
          </S.TableRegister>);
      }

      case 'HasTracking': {
        return <Toggle isChecked={value} onChange={() => this.handleConfirmationModal(row)} small />;
      }

      default:
        return value;
    }
  };

  onSearch(query) {
    const { dispatch, currentCustomerData } = this.props;

    dispatch(getCustomerUsersList({
      name: query,
      taxNumber: currentCustomerData.cnpjDest,
      page: 1,
      take: 5
    }));
  };

  handleAddCustomer() {
    const { setShowTable, setShowNewForm } = this.props;

    setShowTable(false);
    setShowNewForm(true);
    this.setState({ showEditForm: false });
  };

  render() {
    const {
      currentPage,
      customerUsersList,
      customerUsersTotal,
      currentCustomerData,
      customerUsersPageLimit,
      showTrackingManager,
      onClose,
      dispatch,
      isFetching,
      showTable,
      showNewForm,
      setShowTable,
      setShowNewForm
    } = this.props;

    const { showEditForm } = this.state;

    return (
      <React.Fragment>
        {showTrackingManager && (
          <S.SidePanel
            onClick={() => {
              setShowTable(true);
              onClose();
            }}
          >
            <S.SidePanelContent
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <S.TrackingManagerHeader>
                <S.TrackingManagerToolbar>
                  <S.HeaderContainer>
                    <h3>Destinatários</h3>
                  </S.HeaderContainer>
                  <S.CloseButton
                    name="close"
                    onClick={() => {
                      setShowTable(true);
                      onClose();
                    }}
                  />
                </S.TrackingManagerToolbar>
              </S.TrackingManagerHeader>
              <S.TrackingManagerContent>
                <S.TrackingManagerAlert>
                  <img src={ErrorIcon} alt="icon" />
                  <S.TrackingManagerAlertText>
                    Cadastre os contatos dos seus clientes e ative o rastreio para
                    que eles possam acompanhar seus pedidos em tempo real através
                    da plataforma Tracking Destinatário Luft.
                  </S.TrackingManagerAlertText>
                </S.TrackingManagerAlert>
                {isFetching ? (
                  <S.LoadingContainer>
                    <CircularProgress color="primary" />
                  </S.LoadingContainer>
                ) : (
                  <React.Fragment>
                    {customerUsersList && showTable && (
                      <React.Fragment>
                        <S.ActionsContainer>
                          <S.StyledSearch
                            placeholder="Buscar"
                            onSearch={query => this.onSearch(query)}
                          />

                          <Button
                            skin="secondary"
                            onClick={this.handleAddCustomer}
                          >
                            Adicionar
                          </Button>
                        </S.ActionsContainer>

                        <TrackingTable
                          errorMessage={null}
                          onRenderCell={this.onRenderCell}
                          headers={this.tableConfig.tableHeaders}
                          actions={this.tableConfig.tableActions}
                          data={customerUsersList}
                          currentCustomerData={currentCustomerData}
                          currentPage={currentPage}
                          totalItems={customerUsersTotal}
                          dispatch={dispatch}
                          pageLimit={customerUsersPageLimit}
                          onCancel={() => {
                            setShowNewForm(false);
                            this.setState({ showEditForm: false });
                            setShowTable(true);
                            onClose();
                          }}
                          onSave={() => {
                            setShowNewForm(false);
                            this.setState({ showEditForm: false });
                            setShowTable(true);
                            onClose();
                          }}
                        />
                      </React.Fragment>
                    )}

                    {!customerUsersList && (
                      <S.FormContainer>
                        <S.NoContactRegistered>
                          Nenhum contato cadastrado.
                        </S.NoContactRegistered>

                        <NewRecipientForm
                          dispatch={dispatch}
                          onClose={onClose}
                          currentCustomer={currentCustomerData.cnpjDest}
                        />
                      </S.FormContainer>
                    )}

                    {!showTable && showNewForm && (
                      <NewRecipientForm
                        dispatch={dispatch}
                        onClose={() => {
                          setShowTable(true);
                          setShowNewForm(false);
                        }}
                        currentCustomer={currentCustomerData.cnpjDest}
                        currentNameCompany={currentCustomerData.destination.name}
                      />
                    )}

                    {!showTable && showEditForm && (
                      <EditRecipientForm
                        dispatch={dispatch}
                        onClose={() => {
                          setShowTable(true);
                          this.setState({ showEditForm: false });
                        }}
                        currentCustomer={currentCustomerData.cnpjDest}
                        currentNameCompany={currentCustomerData.destination.name}
                        currentUser={this.state.currentCustomerUser}
                      />
                    )}

                    {this.state.showConfirmationModal.open && (
                      <ConfirmationModal
                        open={this.state.showConfirmationModal.open}
                        onClose={() => this.setState({ showConfirmationModal: {open: false, data: null } })}
                        onSubmit={() => this.handleSubmitChangeTracking()}
                      />
                    )}
                  </React.Fragment>
                )}
              </S.TrackingManagerContent>
            </S.SidePanelContent>
          </S.SidePanel>
        )}
      </React.Fragment>
    );
  };
};

function mapStateToProps(state) {
  return {
    loggedCompanyId: state.auth.activeCompanyId,
    currentPage: state.tracking.filters.currentPage,
  };
}

export default connect(mapStateToProps)(TrackingManager);
